import { useTranslation } from 'react-i18next'
import { pulseTooltipOverrides } from '@/shared/components/PulseScope/styled-components'
import useContractActions from '../../../../ContractsTable/cells/useContractActions'
import { Contract } from '../../../../types'
import {
  abandonIconButtonOverrides,
  fillActionButtonOverrides,
  iconActionButtonOverrides,
} from '../../styled-components'

interface UseRowActionsParams {
  contract: Contract
  getContracts: () => void
  formInitUrl: string
}

const useRowActions = ({ contract, getContracts, formInitUrl }: UseRowActionsParams) => {
  const { t } = useTranslation()
  const actions = useContractActions({
    contractId: contract.id,
    contactZohoId: contract.contactZohoId,
    contractUserId: contract.createdById,
    statusRaw: contract.statusRaw as string,
    contactId: contract.contactId,
    getContracts,
    formInitUrl,
  })

  return {
    ...actions,
    editLabel: t('dashboard:overview.open'),
    commentsLabel: t('contractsTable:comments'),
    abandonLabel: t('contractsTable:abandon'),
    editOverrides: fillActionButtonOverrides,
    iconOverrides: iconActionButtonOverrides,
    abandonOverrides: abandonIconButtonOverrides,
    tooltipOverrides: pulseTooltipOverrides,
  }
}

export default useRowActions
